var E = /* @__PURE__ */ ((r) => (r.BY_SLIDE = "by-slide", r.BY_PAGE = "by-page", r))(E || {}), e = /* @__PURE__ */ ((r) => (r.ENTER_FROM_RIGHT = "enter-from-right", r.CROSSFADE = "crossfade", r))(e || {}), t = /* @__PURE__ */ ((r) => (r.NEXT = "next", r.PREVIOUS = "previous", r))(t || {});
export {
  e as RocheUISlideAnimation,
  t as RocheUISlideDirection,
  E as RocheUISlideTransition
};
